// extracted by mini-css-extract-plugin
module.exports = {"container":"Static_container__F3tH0","mainTabs":"Static_mainTabs__D1rxK","notificationIcon":"Static_notificationIcon__3FeGB","totalCounter":"Static_totalCounter__kUzCF"};